module.exports = __webpack_public_path__ + "img/62.26c6b247.svg";